var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconChevronDown = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7 9.3C18.3 8.9 17.7 8.9 17.3 9.3L12 14.6L6.7 9.3C6.3 8.9 5.7 8.9 5.3 9.3C4.9 9.7 4.9 10.3 5.3 10.7L11.3 16.7C11.5 16.9 11.8 17 12 17C12.2 17 12.5 16.9 12.7 16.7L18.7 10.7C19.1 10.3 19.1 9.7 18.7 9.3Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconChevronDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconChevronDown.74e4b7a0da6fa7e2c20d82be77fcb394.svg";